import { Grid, Typography } from '@mui/material'
import React from 'react'
import { routeName } from '../../../routes/routeName'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as MenuIBSCIcon } from '../../../assets/icons/menuIBSC.svg';

export default function IBSCOnlineAdmission() {
  return (
    <div className='w-full flex flex-col items-center justify-center'>
      <div className='flex flex-col items-center justify-center py-[24px] md:py-[50px]'>
        <div style={{textAlign:'center'}}>
        <Typography variant='h5'>IBSC Online Admission</Typography>
        <Typography >Please select the item you want</Typography>

        </div>
      </div>
      <div className='flex items-center justify-center gap-[20px] max-w-[1180px]'>
        <Grid container spacing={2} sx={{
          justifyContent: "center",
          alignItems: "center",
        }}>
          {[
           
            {
              link: routeName.admission.CheckPDPA,
              name: 'IBSC Online Admission',
              icon: <MenuIBSCIcon/>
            },
          
           
          ].map((item: any) => {
            return (
              <CardComponent link={item.link} name={item.name} icon={item.icon} size={{md:3}}/>
            )
          })}
        </Grid>
      </div>
    </div >
  )
}
const CardComponent = (props: any) => {
  const { link, name, icon, size } = props
  const navigate = useNavigate()

  return (
    <Grid item xs={1} md={4} className='flex items-center justify-center mt-[10px] cursor-pointer transition duration-300 ease-in-out hover:scale-105'>
      <div onClick={() => navigate(link)} className="flex items-center flex-col shadow-[0px_10px_15px_-3px_#1018281A] w-[184px] h-[190px] pt-[16px] pr-[10px] pb-[16px] pl-[10px] gap-[16px] rounded-lg">
        {icon}
        <Typography sx={{ fontSize:"14px" }} align='center'>{name}</Typography>
      </div>
    </Grid>
  )
}